import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '../redux/reducers';
import { createPromise } from 'redux-promise-middleware';
import { PROMISE_TYPE_SUFFIXES } from '../redux/actions/types';

const devMode = process.env.NODE_ENV === 'development';

const promiseMiddleWare = createPromise({
  promiseTypeSuffixes: PROMISE_TYPE_SUFFIXES
});

const store = configureStore({
  reducer: rootReducer,
  devTools: devMode,
  middleware: getDefaultMiddleware => getDefaultMiddleware({
    serializableCheck: false,
    immutableCheck: false
  }).concat(promiseMiddleWare)
});

export default store;
